export default __webpack_public_path__ + "static/media/add-event.a9425467.svg";